import { Controller } from "@hotwired/stimulus"
import $ from 'jquery'
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["container", "form", "field", "details", "name",
    "predicate", "value", "formAttribute", "formPredicate", "formValue",
    "formPredicateText", "formPredicateNumber", "formPredicateBoolean",
    "formPredicateDateTime", "formPredicateEnum", "formPredicateArray",
    "formValueText", "formPredicateTextHasMany", "formValueNumber",
    "formValueBoolean", "formValueEnum", "formValueEnumMulti",
    "formValueDateTime", "formValueArray", "formValueTextLabel", "addButton"]
  static values = {
    initialized: Boolean,
    translations: Object,
    skipCollapse: Boolean,
  }

  connect() {
    if (!this.initializedValue) {
      this.processAttributeTypes()
      this.filterPredicates()
      this.filterValueInputs()
      this.collapseOptGroups()
      this.sortOptgroups()
      flatpickr(this.formValueDateTimeTarget, { dateFormat: 'Y-m-d', allowInput: true })
      if (this.isPopulated()) {
        this.displayFilterRuleSummary()
      } else {
        $(this.formAttributeTarget).find('option:contains("Choose an attribute")').prop('selected', true)
        this.filterPredicates()
        $(this.containerTarget).addClass('no-data')
      }
      $(this.containerTarget).addClass('visible')
      this.initializedValue = true
    }
  }

  toggle(event) {
    if (
      this.element.contains(event.target) &&
      !this.formTarget.contains(event.target)
    ) {
      $(this.formTarget).toggle()
      this.syncExpanded()
    }
    event.preventDefault()
  }

  hide(event) {
    if (!this.element.contains(event.target) && !$('.flatpickr-calendar')[0].contains(event.target)) {
      $(this.formTarget).hide()
      this.syncExpanded()
    }
  }

  syncExpanded() {
    if (!this.hasAddButtonTarget) return

    const expanded = $(this.formTarget).css("display") !== "none"
    this.addButtonTarget.setAttribute("aria-expanded", expanded)
  }

  displayFilterRuleSummary() {
    $(this.nameTarget).text(this.fetchTranslationsValue(this.attributeValue))
    $(this.predicateTarget).text(this.predicateValue)
    $(this.detailsTarget).show()

    if (this.isValuelessPredicate(this.predicateValue)) {
      $(this.predicateTarget).css({ fontWeight: 900 })
      $(this.valueTarget).hide()
    } else if (this.isMultiEnumPredicate(this.predicateValue)) {
      const labels = (this.searchValues || []).map((v) =>
        this.fetchTranslationsValue(v.split('::').pop())
      )
      $(this.valueTarget).text(labels.join(", "))
    } else {
      $(this.valueTarget).text(this.fetchTranslationsValue(this.searchValue.split('::').pop()))
    }
  }

  fetchTranslationsValue(term) {
    if (this.translationsValue[term]) {
      // If the value is present as a key in `translations` (passed to the filter partial),
      // fetch the value for display
      // Split by :: is a no-op in most cases
      return this.translationsValue[term].split("::")[0]
    } else {
      // Otherwise just display it
      return term
    }
  }

  // Is the filter "complete", i.e. does every filter field have a value?
  isPopulated() {
    this.attributeValue = $(this.formAttributeTarget).val()
    this.predicateValue = $(this.formPredicateTarget).parent().find('select:enabled').find('option:selected').text()

    // for multi-select, need to detect an array of search values
    if (this.isMultiEnumPredicate(this.predicateValue) && this.hasFormValueEnumMultiTarget) {
      this.searchValues = $(this.formValueEnumMultiTarget).val() || []
      return (this.attributeValue != "" && this.predicateValue != "" && this.searchValues.length > 0)
    }

    this.searchValue = $(this.formValueTarget).val()
    return (this.attributeValue != "" && this.predicateValue != "" && this.searchValue != "")
  }

  handleAttributeChange() {
    this.filterPredicates()
    this.filterValueInputs()
    this.resetSearchValue()
  }

  resetSearchValue() {
    this.searchValue = ""
    $(this.formValueTarget).val(this.searchValue)
  }

  // Filter the possible predicates appropriate to the attribute type being searched
  filterPredicates() {
    const typeMap = {
      'enum': this.formPredicateEnumTarget,
      'array': this.formPredicateArrayTarget,
      'string': this.formPredicateTextTarget,
      'text': this.formPredicateTextTarget,
      'text::hasmany': this.formPredicateTextHasManyTarget,
      'integer': this.formPredicateNumberTarget,
      'float': this.formPredicateNumberTarget,
      'bigint': this.formPredicateNumberTarget,
      'boolean': this.formPredicateBooleanTarget,
      'datetime': this.formPredicateDateTimeTarget,
      'date': this.formPredicateDateTimeTarget
    }
    let selectedValue = $(this.formAttributeTarget).find('option:selected').attr('data-attr-type')
    if ($(this.formAttributeTarget).find('option:selected').attr('data-attr-has-many') == "HasMany") {
      selectedValue = `${selectedValue}::hasmany`
    }
    let predicateSelector = typeMap[selectedValue]

    $(this.formPredicateEnumTarget).prop("disabled", true).hide()
    $(this.formPredicateArrayTarget).prop("disabled", true).hide()
    $(this.formPredicateTextTarget).prop("disabled", true).hide()
    $(this.formPredicateTextHasManyTarget).prop("disabled", true).hide()
    $(this.formPredicateNumberTarget).prop("disabled", true).hide()
    $(this.formPredicateBooleanTarget).prop("disabled", true).hide()
    $(this.formPredicateDateTimeTarget).prop("disabled", true).hide()
    $(predicateSelector).prop("disabled", false).show()

    this.filterValueInputs()
  }

  filterValueInputs() {
    let isEnum = $(this.formAttributeTarget).find('option:selected').attr('data-attr-type') == "enum"
    let selectedValue = $(this.formPredicateTarget).parent().find('select:enabled').find('option:selected').text()
    $(this.formValueTargets).prop("disabled", true).hide()
    $(this.formValueTextLabelTargets).hide()

    if (this.isValuelessPredicate(selectedValue)) {
      $(this.formValueBooleanTarget).prop("disabled", false).hide().val(1)
    } else if (isEnum) {
      const enumOpts = JSON.parse($(this.formAttributeTarget).find('option:selected').attr('data-attr-enums'))
      const isMulti = this.isMultiEnumPredicate(selectedValue) && this.hasFormValueEnumMultiTarget
      const target = isMulti ? this.formValueEnumMultiTarget : this.formValueEnumTarget

      // Clear out existing options if set as this is a shared dropdown
      if ($(target).find('option').length != 0) {
        $(target).html("")
      }
      $.each(enumOpts, (text, val) => {
        // We want to use a special format for integer based enums so that when
        // the filter is summarized we can show the actual text value. We don't
        // need that if the value is a true postgres enum as they are
        // self-descriptive. Use Number.isFinite, not the truthiness of
        // parseInt — `parseInt(0)` is falsy but 0 is still a valid enum int.
        const parsed = parseInt(val)
        const optionVal = Number.isFinite(parsed) ? `${parsed}::${text}` : val
        const optionLabel = this.fetchTranslationsValue(text)
        $(target).append($('<option></option>').val(optionVal).html(optionLabel))
      })

      if (isMulti) {
        // Pre-select whatever the per-value inputs hold (the "0::ignored",
        // "1::accepted", … values that ransack rendered for the current URL).
        const currentValues = Array.from(
          new Set(
            this.formValueTargets
              .filter(el => el !== this.formValueEnumMultiTarget)
              .map(el => $(el).val())
              .filter(Boolean)
          )
        )
        $(target).val(currentValues)
        $(target).prop("disabled", false).show()

      } else {
        this.isPopulated()
        $(target).prop("disabled", false).show().focus().val(this.searchValue)
      }

    } else if (this.isDatePickerPredicate(selectedValue)) {
      $(this.formValueDateTimeTarget).prop("disabled", false).show().focus()
    } else if (this.isNumberPredicate(selectedValue)) {
      $(this.formValueNumberTarget).prop("disabled", false).show().focus()
    } else if (this.isRelativeTimePredicate(selectedValue)) {
      $(this.formValueNumberTarget).prop("disabled", false).show().focus()
    } else if (this.isTextPredicate(selectedValue)) {
      $(this.formValueTextLabelTargets).show()
      $(this.formValueTextTarget).prop("disabled", false).show().focus()
    }
  }

  processAttributeTypes() {
    $(this.formAttributeTarget).find('option').each((_index, option) => {
      let rawDataType, dataType, label, formattedLabel, secondary, secondaryLabel, value
      value = $(option).attr('value')

      if ($(option).text() != "") {
        [rawDataType, label] = $(option).text().split('|')

        if (!$.isEmptyObject(this.translationsValue)) {
          if (this.translationsValue[value]) {
            [label, secondaryLabel] = this.translationsValue[value].split('::')
          } else if ($(option).attr('selected')) {
            label = label;
          } else {
            $(option).remove()
            return true
          }
        }

        if (rawDataType) {
          [dataType, secondary] = rawDataType.split("::")
        }

        $(option).attr('data-attr-type', dataType.trim())

        if (dataType.trim() == "boolean" && label.slice(-1) != "?") {
          formattedLabel = `${label}?`
        } else {
          formattedLabel = label
        }

        if (dataType.trim() == "enum") {
          $(option).attr('data-attr-enums', secondary)
        }

        if (dataType.trim() == "text" && secondaryLabel) {
          $(option).attr('data-attr-has-many', secondaryLabel)
        }

        if (dataType.trim() == "array") {
          $(option).attr('data-attr-array-subtype', secondary)
        }

        $(option).text(`${formattedLabel} (${dataType.trim()})`)
      } else {
        $(option).text("Choose an attribute").prop("disabled", true).attr("label", "Choose an attribute")
      }
    })
  }

  collapseOptGroups() {
    if (!$.isEmptyObject(this.translationsValue) && !this.skipCollapseValue) {
      $(this.formAttributeTarget).find("optgroup").children().each((_index, elm) => {
        $(elm).parent().after(elm)
      })
      $(this.formAttributeTarget).find("optgroup").remove()
    }
  }

  sortOptgroups() {
    let originalValue = $(this.formAttributeTarget).val()
    $(this.formAttributeTarget).find("optgroup").each((index, elmt) => {
      let result = $(elmt).find("option").toArray().sort((option1, option2) => option1.innerHTML.localeCompare(option2.innerHTML))
      $(result).appendTo(elmt)
    })

    $(this.formAttributeTarget).val(originalValue)
  }

  isValuelessPredicate(predicate) {
    const valuelessPredicates = ['is not null', 'is null', 'is true', 'is false', 'is present']
    return valuelessPredicates.includes(predicate)
  }

  isMultiEnumPredicate(predicate) {
    return ["in", "not in"].includes(predicate)
  }

  isNumberPredicate(predicate) {
    const numberPredicates = ['equals', 'not equal to', 'less than',
      'less than or equal to', 'greater than', 'greater than or equal to']
    return numberPredicates.includes(predicate)
  }

  isRelativeTimePredicate(predicate) {
    const relativeTimePredicates = ['is older than in days ago',
      'is newer than in days ago', 'is older than in hours ago',
      'is newer than in hours ago']
    return relativeTimePredicates.includes(predicate)
  }

  isTextPredicate(predicate) {
    const textPredicates = ["matches", "doesn't match", "contains", "doesn't contain",
      "starts with", "doesn't start with", "ends with", "doesn't end with",
      "is present", "is null", "has all items in list", "has any items in list"]
    return textPredicates.includes(predicate)
  }

  isDatePickerPredicate(predicate) {
    const datePredicates = ['is before', 'is after']
    return datePredicates.includes(predicate)
  }
}
